<section
  class="w-screen h-screen bg-white flex align-items-center justify-content-center"
>
  <div
    class="h-full flex align-items-center justify-content-center form-container flex-column relative"
  >
    <form
      [formGroup]="loginForm"
      (ngSubmit)="onSubmit()"
      class="p-4 border-round w-25rem"
    >
      <div class="mb-3 flex align-items-center justify-content-center">
        <img
          src="assets/images/main-logo.png"
          alt="Image"
          height="50"
          class="mb-4 mt-5"
        />
      </div>

      <div>
        <!-- <app-input
          [options]="{
            type: 'text',
            containerClass: 'mb-0',
            label: 'Email',
            placeholder: 'example@example.com',
            formControlName: 'email'
          }"
        >
        </app-input>

        <app-input-password
          [options]="{
            containerClass: 'mb-0',
            label: 'Password',
            formControlName: 'password',
            value: '',
            disabled: false,
            validators: {
              required: true,
              maxLength: 200
            }
          }"
        ></app-input-password> -->

        <p-messages
          [(value)]="errorMessage"
          [enableService]="true"
        ></p-messages>

        <button (click)="onSubmit()" type="button" class="main-btn w-full">
          Sign in with
          <img
            style="width: 24px; height: auto"
            src="assets/images/azure.png"
            alt=""
          />
        </button>
      </div>
    </form>
  </div>
</section>
